import React from 'react'

const CarWhiteScg = ({ width }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      viewBox='0 0 17.657 15.835'
    >
      <path
        id='car-svgrepo-com_3_'
        data-name='car-svgrepo-com (3)'
        d='M2,13.5v5.672a.66.66,0,0,0,.66.66h1.42a.66.66,0,0,0,.651-.552L5.075,17.2H16.511l.347,2.088a.66.66,0,0,0,.651.552H18.93a.66.66,0,0,0,.66-.66V13.5a5.238,5.238,0,0,0-.88-2.906l-.686-1.029a1.754,1.754,0,0,1-.157-.29h.874a.66.66,0,0,0,.59-.365l.22-.44a.66.66,0,0,0-.589-.954H17.479l-.273-1.36a2.2,2.2,0,0,0-1.658-1.71A21.382,21.382,0,0,0,10.793,4a21.377,21.377,0,0,0-4.755.449,2.2,2.2,0,0,0-1.659,1.71l-.273,1.36H2.624a.66.66,0,0,0-.589.954l.22.44a.66.66,0,0,0,.589.365h.875a1.759,1.759,0,0,1-.157.29L2.876,10.6A5.238,5.238,0,0,0,2,13.5ZM16.037,9.282a3.519,3.519,0,0,0,.3.877H5.25a3.491,3.491,0,0,0,.3-.877L6.1,6.5a.44.44,0,0,1,.332-.343,19.822,19.822,0,0,1,4.356-.4,19.708,19.708,0,0,1,4.356.4.44.44,0,0,1,.333.342l.555,2.777ZM5.075,14.557a1.32,1.32,0,1,0-1.32-1.32A1.32,1.32,0,0,0,5.075,14.557Zm12.756-1.32a1.32,1.32,0,1,1-1.32-1.32A1.32,1.32,0,0,1,17.831,13.237Z'
        transform='translate(-1.965 -4)'
        fill='#fff'
        fillRule='evenodd'
      />
    </svg>
  )
}

export default CarWhiteScg
